import { createSlice } from "@reduxjs/toolkit"
import { ErrorType } from "@/shared/types"
import { ICompanyTransactionsStatisticsState } from "./types"
import { fetchLatestTransactions } from "./company-transactions-statistics-thunk"

const initialState: ICompanyTransactionsStatisticsState = {
    latestTransactions: [],
    transactionDetails: null,
    isLoading: false,
    isFirstLoad: true,
    error: null
}

const companyTransactionsStatisticsSlice = createSlice({
    name: 'companyTransactionsStatistics',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchLatestTransactions.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchLatestTransactions.fulfilled, (state, action) => {
                state.isLoading = false
                state.isFirstLoad = false
                state.latestTransactions = action.payload.items
                state.transactionDetails = action.payload.aggregate
                state.error = null
            })
            .addCase(fetchLatestTransactions.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload as ErrorType ?? null
            })
    },
})

export default companyTransactionsStatisticsSlice.reducer

